import http from "../../../../http-axios.function";


const create = (data) => {
    return http.post(`/super_admin/architecture/service_users/create`, {
        headers: {
            'Content-Type': 'multipart/form-data;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
        }, data
    });
};


const fetchList = (data) => {
    return http.post(`/super_admin/architecture/service_users/fetch`, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
        }, data
    });
};


const fetchSingle = (data) => {
    return http.post(`/super_admin/architecture/service_users/fetch_single`, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
        }, data
    });
};


const update = (data) => {
    return http.post(`/super_admin/architecture/service_users/update`, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
        }, data
    });
};


const updateEmail = (data) => {
    return http.post(`/super_admin/architecture/service_users/update_email`, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
        }, data
    });
};


const updatePhoneNumber = (data) => {
    return http.post(`/super_admin/architecture/service_users/update_phone_number`, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
        }, data
    });
};


const changeStatus = (data) => {
    return http.post(`/super_admin/architecture/service_users/toggle_status`, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
        }, data
    });
};


const trash = (data) => {
    return http.post(`/super_admin/architecture/service_users/delete`, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
        }, data
    });
};



const ServerServiceUsers = {
    updateEmail,
    updatePhoneNumber,
    fetchList,
    fetchSingle,
    create,
    update,
    changeStatus,
    trash,
};
export default ServerServiceUsers;